// extracted by mini-css-extract-plugin
module.exports = {"tab-container":"walkthroughTab_tab-container__3MUnU","selected-tab-container":"walkthroughTab_selected-tab-container__ifP1g"};